import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Grid,
  MenuItem,
  IconButton,
} from "@mui/material";
import Swal from "sweetalert2";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";

const ModalAgregarUsuarios = ({ fetchUsuarios, alerta }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    password: "",
    rol: "",
  });

  const roles = [
    { value: "admin", label: "Administrador" },
    { value: "asociado", label: "Editor" },
    { value: "visita", label: "Visita" },
    { value: "inhabilitado", label: "Inhabilitado" },
  ];

  useEffect(() => {
    if (!open) {
      // Reset the form when the modal is closed
      setFormData({ nombre: "", email: "", password: "", rol: "" });
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre || !formData.email || !formData.password || !formData.rol) {
      Swal.fire({
        title: "Campos incompletos",
        text: "Por favor completa todos los campos.",
        icon: "warning",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://apimedidas.ahouseinterior.com/agregar_usuario.php",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success") {
        Swal.fire({
          title: "Usuario agregado",
          text: `El usuario ${formData.nombre} fue agregado correctamente.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        fetchUsuarios(); // Recarga la lista de usuarios
        setOpen(false); // Cierra el modal
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.message || "No se pudo agregar el usuario.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error al agregar el usuario:", error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al conectar con el servidor.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  return (
    <>
      <IconButton color="primary" onClick={() => setOpen(true)}>
        <AddIcon />
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Agregar Usuario</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Correo Electrónico"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Contraseña"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Rol"
                  name="rol"
                  value={formData.rol}
                  onChange={handleChange}
                  select
                  fullWidth
                  required
                >
                  {roles.map((role) => (
                    <MenuItem key={role.value} value={role.value}>
                      {role.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="error">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalAgregarUsuarios;
